import Avatar from './Avatar';

export default {
	Avatar
};


// WEBPACK FOOTER //
// ./src/components/index.js